import {
  getPermissions as publicGetPermissions,
  updatePermissions as publicUpdatePermissions,
  addSpecialPermissions as publicAddSpecialPermissions,
  updateSpecialPermissions as publicUpdateSpecialPermissions,
  removeSpecialPermissions as publicRemoveSpecialPermissions,
  getMyPermissions as publicGetMyPermissions,
} from './data-v1-data-permissions-permissions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getPermissions: MaybeContext<
  BuildRESTFunction<typeof publicGetPermissions> & typeof publicGetPermissions
> = /*#__PURE__*/ createRESTModule(publicGetPermissions);
export const updatePermissions: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePermissions> &
    typeof publicUpdatePermissions
> = /*#__PURE__*/ createRESTModule(publicUpdatePermissions);
export const addSpecialPermissions: MaybeContext<
  BuildRESTFunction<typeof publicAddSpecialPermissions> &
    typeof publicAddSpecialPermissions
> = /*#__PURE__*/ createRESTModule(publicAddSpecialPermissions);
export const updateSpecialPermissions: MaybeContext<
  BuildRESTFunction<typeof publicUpdateSpecialPermissions> &
    typeof publicUpdateSpecialPermissions
> = /*#__PURE__*/ createRESTModule(publicUpdateSpecialPermissions);
export const removeSpecialPermissions: MaybeContext<
  BuildRESTFunction<typeof publicRemoveSpecialPermissions> &
    typeof publicRemoveSpecialPermissions
> = /*#__PURE__*/ createRESTModule(publicRemoveSpecialPermissions);
export const getMyPermissions: MaybeContext<
  BuildRESTFunction<typeof publicGetMyPermissions> &
    typeof publicGetMyPermissions
> = /*#__PURE__*/ createRESTModule(publicGetMyPermissions);

export {
  AccessLevel,
  Access,
  SubjectType,
  SubjectContextType,
  SimpleConditionOperator,
  JoinedConditionOperator,
  Effect,
  PolicyType,
  PolicyOwnerType,
} from './data-v1-data-permissions-permissions.universal.js';
export {
  DataPermissions,
  SpecialPermissions,
  SpecialPermissionsSubjectOneOf,
  SpecialPermissionsDraftItemsPluginPermissions,
  DraftItemsPluginPermissions,
  GetPermissionsRequest,
  GetPermissionsResponse,
  UpdatePermissionsRequest,
  UpdatePermissionsResponse,
  AddSpecialPermissionsRequest,
  AddSpecialPermissionsResponse,
  UpdateSpecialPermissionsRequest,
  UpdateSpecialPermissionsResponse,
  RemoveSpecialPermissionsRequest,
  RemoveSpecialPermissionsResponse,
  GetMyPermissionsRequest,
  GetMyPermissionsResponse,
  GetMyPermissionsResponseDraftItemsPluginPermissions,
  MigrateCustomRolesRequest,
  MigrateCustomRolesResponse,
  PolicyAssignmentsUpdated,
  PolicyAssignmentsUpdatedEventOneOf,
  PolicyAssigned,
  Subject,
  SubjectContext,
  PolicyAssignment,
  ResourcePath,
  Resource,
  PolicyCondition,
  ConditionType,
  ConditionTypeOfOneOf,
  SimpleCondition,
  SimpleConditionValue,
  SimpleConditionValueValueOneOf,
  JoinedCondition,
  EnvironmentCondition,
  EnvironmentConditionConditionOneOf,
  ExperimentCondition,
  Condition,
  ConditionOperator,
  ConditionOperatorOperatorsOneOf,
  EqualOperator,
  ConditionValue,
  ConditionValueValueOneOf,
  LikeOperator,
  ExperimentOperator,
  DependOnOperator,
  PolicyUnassigned,
  PolicyAssignmentUpdated,
  Empty,
  PolicyAuthorizationDataUpdated,
  PolicyStatement,
  PolicyOwner,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  UpdateSpecialPermissions,
} from './data-v1-data-permissions-permissions.universal.js';
export {
  AccessLevelWithLiterals,
  AccessWithLiterals,
  SubjectTypeWithLiterals,
  SubjectContextTypeWithLiterals,
  SimpleConditionOperatorWithLiterals,
  JoinedConditionOperatorWithLiterals,
  EffectWithLiterals,
  PolicyTypeWithLiterals,
  PolicyOwnerTypeWithLiterals,
  GetPermissionsApplicationErrors,
  UpdatePermissionsApplicationErrors,
  AddSpecialPermissionsApplicationErrors,
  UpdateSpecialPermissionsApplicationErrors,
  RemoveSpecialPermissionsApplicationErrors,
  GetMyPermissionsApplicationErrors,
} from './data-v1-data-permissions-permissions.universal.js';
